import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { errorToast } from '../../utils/errorToast';
import './ClickToCopy.scss';

const ClickToCopy = ({ text, displayText, className = '', style = {}, showIcon = true }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            toast.success('Copied to clipboard!');

            setTimeout(() => {
                setCopied(false);
            }, 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
            errorToast('Failed to copy to clipboard');
        }
    };

    return (
        <div className={`click-to-copy d-inline-flex align-items-center ${className}`} style={style}>
            <span className="click-to-copy-text">{displayText || text}</span>
            {showIcon && (
                <button
                    type="button"
                    className="click-to-copy-btn btn btn-link p-0 ms-2 text-decoration-none"
                    onClick={handleCopy}
                    title="Copy to clipboard"
                >
                    <span className={`fas ${copied ? 'fa-check text-success' : 'fa-copy text-primary'}`} />
                </button>
            )}
        </div>
    );
};

export default ClickToCopy;
